import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { foundItems } from "../../../features/LostFound/dummy/fountItems";
import { listedLostItems } from "../../../features/LostFound/dummy/listedLostItems";

// Initial state
const initialState = {
  loading: null,
  loaded: null,
  error: null,
  data: null,
  list: null,
};

// Slice
const checkListedItemSlice = createSlice({
  name: "checkListedItem",
  initialState,
  reducers: {
    initItem(state) {
      return {
        ...state,
        loading: null,
        loaded: null,
        error: null,
        data: null,
        list: null,
      };
    },
    checkItem(state) {
      return { ...state, loading: true, error: false };
    },
    setList(state, action) {
      const { list } = action.payload;
      return { ...state, list };
    },
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
  },
});

export const {
  initItem,
  checkItem,
  setList,
  fetchDataSuccess,
  fetchDataFailure,
} = checkListedItemSlice.actions;

export default checkListedItemSlice.reducer;

//saga
function* fetchDataSaga(action) {
  const peerIp = yield select((state) => state.peerIp.ip);
  try {
    const { headers = {}, apiUrl, data } = action.payload;
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      }
    });
    const response = yield call(apiService.post, apiUrl, data);

    // const response = listedLostItems;
    if (response?.data) {
      const { result_code, result_data } = response.data;
      if (result_code === "20000") {
        yield put(setList({ list: result_data }));
      }
    }
    yield put(fetchDataSuccess(response.data));
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

// API 호출을 감시하는 Saga 함수
export function* checkListedItemSaga() {
  yield takeLatest(checkItem.type, fetchDataSaga);
}
